import {
  ActiveCouponsDataRoutePath,
  ActiveCouponsDataRouteType
} from "routes/data-routes/billing-data/coupons/active-coupons/route.meta";
import { loader } from "routes/data-routes/billing-data/coupons/active-coupons/loader";
import { action } from "routes/data-routes/billing-data/coupons/active-coupons/action";
import { useActiveCoupons as hook } from "routes/data-routes/billing-data/coupons/active-coupons/useActiveCoupons";


const ActiveCouponsDataRouteDefinition: ActiveCouponsDataRouteType = {
  route: {
    path: ActiveCouponsDataRoutePath,
    loader,
    action,
  },
  useActiveCoupons: hook
};

export const { route: ActiveCouponsDataRoute, useActiveCoupons } = ActiveCouponsDataRouteDefinition;
